import { useQuery } from "react-query";
import { getData } from "../newApis/apiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";

const getLoanRepaymentReport = async ({
  FromDate,
  ToDate,
  Page,
  PageSize,
  AggregatorId,
}) => {
  let queryParams = `page=${Page}&PageSize=${PageSize}`;
  if (FromDate) {
    queryParams = `${queryParams}&FromDate=${FromDate}`;
  }
  if (ToDate) {
    queryParams = `${queryParams}&ToDate=${ToDate}`;
  }
  if (AggregatorId) {
    queryParams = `${queryParams}&AggregatorId=${AggregatorId}`;
  }
  const data = await getData(
    `${ajaxEndpoints.REPAYMENT_LOAN_REPORT}?${queryParams}`
  );
  return data;
};

export default function useLoanRepaymentReport({
  FromDate,
  ToDate,
  Page,
  PageSize,
  AggregatorId,
}) {
  return useQuery(
    [
      { FromDate, ToDate, Page, PageSize, AggregatorId },
      "getLoanRepaymentReport",
    ],
    getLoanRepaymentReport
  );
}
